import PayablesTableSearchQuery from '../models/payablesTableSearchQuery';

enum PayablesTableQueryType {
  GetDropdownOptions,
  GetPage,
  DeletePayment,
}

interface QueryGetDropdownOptions {
  type: PayablesTableQueryType.GetDropdownOptions;
}

interface QueryGetPage {
  type: PayablesTableQueryType.GetPage;
  query: PayablesTableSearchQuery;
}

interface QueryDeletePayment {
  type: PayablesTableQueryType.DeletePayment;
  paymentId: string;
}

type PayablesTableQuery = QueryGetDropdownOptions | QueryGetPage | QueryDeletePayment;

export { PayablesTableQueryType };
export default PayablesTableQuery;
